import { useSearchParams } from 'react-router';
import { formatDay } from '../lib/format';
import { PRESETS, rangeFromParams, type Range } from '../lib/range';

/** The selected range, from the URL, so views can be bookmarked and shared. */
export function useRange(): Range {
  const [params] = useSearchParams();
  return rangeFromParams(params);
}

export function RangePicker() {
  const [params, setParams] = useSearchParams();
  const range = rangeFromParams(params);
  return (
    <div className="flex items-center gap-3 flex-wrap">
      <span className="text-sm text-gray-600 tabular">
        {formatDay(range.from)} – {formatDay(range.to, true)}
      </span>
      <div className="inline-flex gap-1 rounded-full bg-gray-100 p-1" role="group" aria-label="Date range">
        {PRESETS.map((p) => (
          <button
            key={p.id}
            type="button"
            aria-pressed={range.preset === p.id}
            onClick={() => {
              const next = new URLSearchParams(params);
              next.delete('from');
              next.delete('to');
              next.set('range', p.id);
              setParams(next, { replace: true });
            }}
            className={`px-3 py-1 text-sm rounded-full transition-colors ${range.preset === p.id ? 'bg-white text-gray-900 shadow-sm font-medium' : 'text-gray-600 hover:text-gray-900'}`}
          >
            {p.label}
          </button>
        ))}
      </div>
    </div>
  );
}
